import type { NEISGetSchoolListParams, NEISGetSchoolListResponse } from './model/neisType'

import { jwtClientAxios } from '.'

import api from '@/api/url'

export const getSchoolListApi = async (params: NEISGetSchoolListParams): Promise<NEISGetSchoolListResponse> => {
  const response = await jwtClientAxios().get(api.neis.GET_SCHOOL_LIST, { params })
  return response.data
}
